/**
 * Kiyoko Beauty — Quiz Results Page
 * Reads RevenueHunt quiz state from localStorage, fetches matching
 * products via Shopify Storefront API, and renders the results page.
 */

(function () {
  "use strict";

  // ── Config ────────────────────────────────────────────────────────────────
  const QUIZ_ID = "PwEZSB";
  const LS_KEY = `revenuehunt-quiz_${QUIZ_ID}`;

  // Block refs for specific questions
  const BLOCK_REFS = {
    skinType: "qbc-307c09b8",
    skinConcerns: "qbc-e772be8f",
    sensitivity: "qbc-329aaeff",
    age: "qbc-dd744cf3",
  };

  // Step base definitions — overridden by theme editor settings after DOM loads
  const STEP_DEFINITIONS = [
    {
      slotRef: "rsbss-0d1a7d8f",
      key: "step1",
      label: "Step 1",
      name: "Oil-Based Cleanser",
      description: "Removes makeup, clears pores and sebum. Apply on dry skin.",
      collectionHandles: ["oil-cleansers"],
    },
    {
      slotRef: "rsbss-d2200082",
      key: "step2",
      label: "Step 2",
      name: "Water-Based Cleanser",
      description:
        "Typically foaming cleansers, these remove dirt and pollutants from your skin.",
      collectionHandles: ["water-based-cleansers"],
    },
    {
      slotRef: "rsbss-61733151",
      key: "step3",
      label: "Step 3",
      name: "Toner & Lotion",
      description:
        "These prep your skin to better absorb the rest of your routine by hydrating and rebalancing skin pH.",
      collectionHandles: ["all-toners"],
    },
    {
      slotRef: "rsbss-33464eed",
      key: "step4",
      label: "Step 4",
      name: "Essence & Serum",
      description:
        "These contain active ingredients to hydrate, brighten, or treat specific skin concerns.",
      collectionHandles: ["all-treatments"],
    },
    {
      slotRef: "rsbss-6a22ed91",
      key: "step5",
      label: "Step 5",
      name: "Moisturize",
      description: "Hydrates your skin by locking in moisture.",
      collectionHandles: ["moisturizers"],
    },
    {
      slotRef: "rsbss-1aec0dfd",
      key: "step6",
      label: "Step 6",
      name: "Protect",
      description:
        "Use sunscreen to protect your skin from harmful UV rays. Apply two fingers worth.",
      collectionHandles: ["suncare"],
    },
  ];

  // Apply theme editor overrides to step definitions
  function applyStepOverrides() {
    STEP_DEFINITIONS.forEach((step) => {
      const k = step.key;
      if (d[k + "Label"]) step.label = d[k + "Label"];
      if (d[k + "Name"]) step.name = d[k + "Name"];
      if (d[k + "Description"]) step.description = d[k + "Description"];
      step.image = d[k + "Image"] || "";
      step.sublabel = d[k + "Sublabel"] || "";
      step.sublabelIcon = d[k + "SublabelIcon"] || "";
    });
  }

  // ── DOM references & settings ─────────────────────────────────────────────
  const container = document.getElementById("qr-container");
  const d = container ? container.dataset : {};

  const quizPageUrl = d.quizUrl || "/pages/kiyokos-skincare-quiz-1";
  const shopDomain = d.shopDomain || window.location.hostname;
  const sfToken = d.storefrontToken || "";
  const klaviyoKey = d.klaviyoKey || "";
  const rewardsPageUrl = d.rewardsPageUrl || "/pages/rewards";

  // Content settings (with fallbacks)
  const settings = {
    heroHeading:
      d.heroHeading || "<p>Here are your personalized skincare routine</p>",
    heroSubtext:
      d.heroSubtext ||
      "<p>Here's your step by step Asian skincare routine, made just for you and your skin.</p>",
    heroImage:
      d.heroImage ||
      "https://cdn.shopify.com/s/files/1/0515/4589/9157/files/quiz-Frame_1000006702.png?v=1778000080",
    heroImageAlt: d.heroImageAlt || "Kiyoko skincare routine",
    rewardsTitle: d.rewardsTitle || "Besties Rewards",
    rewardsText:
      d.rewardsText ||
      "You've earned <strong>100 Points</strong> for completing this quiz! Please allow 10 minutes for the points to reflect in your balance.",
    showRewards: d.rewardsShow !== "false",
    bundleHeading: d.bundleHeading || "Save 10% on your routine",
    bundleSubtext:
      d.bundleSubtext ||
      "Add all recommended products to your cart to unlock exclusive bundle offer.",
    bundleBtnText: d.bundleBtnText || "Add All to Cart",
    stickyRetakeText: d.stickyRetakeText || "Retake Quiz",
    stickyRetakeTextMobile: d.stickyRetakeTextMobile || "Retake",
    stickyRetakeIcon: d.stickyRetakeIcon || "",
    stickyDiscountText: d.stickyDiscountText || "Add All & Get 10% Off",
    stickyDiscountTextMobile: d.stickyDiscountTextMobile || "Add All",
    stickyAtcIcon: d.stickyAtcIcon || "",
    emailHeading:
      d.emailHeading || "Don't lose your results! Enter your email to save it.",
    emailFinePrint:
      d.emailFinePrint ||
      "By submitting your email, you agree to joining our email list. Unsubscribe anytime.",
    emailImage:
      d.emailImage ||
      "https://cdn.shopify.com/s/files/1/0515/4589/9157/files/quiz-Frame_1000006702.png?v=1778000080",
    showEmail: d.emailShow !== "false",
    colorLavender: d.colorLavender || "#CAC4F4",
    colorLavenderLight: d.colorLavenderLight || "#F0ECFB",
    colorLavenderMid: d.colorLavenderMid || "#E9E4ED",
    colorAccent: d.colorAccent || "#e94560",
    colorBlack: d.colorBlack || "#171717",
    fontHeading: d.fontHeading || "Satoshi",
    fontBody: d.fontBody || "Satoshi",
    fontSizeHeading: d.fontSizeHeading || "36",
    fontSizeBody: d.fontSizeBody || "15",
    fontSizeStepHeading: d.fontSizeStepHeading || "26",
    fontSizeProductTitle: d.fontSizeProductTitle || "13",
    fontSizePrice: d.fontSizePrice || "14",
    fontSizeButton: d.fontSizeButton || "13",
  };

  // Collect all added variant IDs for "Add All to Cart"
  let allVariantIds = [];

  // ── Entry point ──────────────────────────────────────────────────────────
  function init() {
    if (!container) return;

    const raw = localStorage.getItem(LS_KEY);
    if (!raw) {
      renderError();
      return;
    }

    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      renderError();
      return;
    }

    const state = parsed.state;
    if (!state) {
      renderError();
      return;
    }

    applyStepOverrides();
    const profile = buildProfile(state);
    renderPage(profile, state);
  }

  // ── Build user profile from answers ──────────────────────────────────────
  function buildProfile(state) {
    const { answers, questions } = state;
    if (!answers || !questions) return {};

    // Build a lookup: blockRef → full choice objects
    const choiceLookup = {};
    questions.forEach((q) => {
      q.blocks.forEach((block) => {
        if (
          block.type === "choice" &&
          block.preferences &&
          block.preferences.choices
        ) {
          choiceLookup[block.ref] = block.preferences.choices;
        }
      });
    });

    // Helper: get selected choice objects for a blockRef
    function getSelected(blockRef) {
      const answer = answers.find((a) => a.blockRef === blockRef);
      if (!answer || !answer.choicesRefs || !answer.choicesRefs.length)
        return [];
      const choices = choiceLookup[blockRef] || [];
      return choices.filter((c) => answer.choicesRefs.includes(c.ref));
    }

    const skinTypeChoices = getSelected(BLOCK_REFS.skinType);
    const concernChoices = getSelected(BLOCK_REFS.skinConcerns);
    const sensitivityChoices = getSelected(BLOCK_REFS.sensitivity);
    const ageChoices = getSelected(BLOCK_REFS.age);

    // Collect all upvoted tags across all answers
    const allUpvotedTags = [];
    answers.forEach((answer) => {
      const choices = choiceLookup[answer.blockRef] || [];
      const selected = choices.filter(
        (c) => answer.choicesRefs && answer.choicesRefs.includes(c.ref),
      );
      selected.forEach((c) => {
        (c.upvotedTagsCollectionsIds || []).forEach((tag) => {
          if (!allUpvotedTags.includes(tag)) allUpvotedTags.push(tag);
        });
      });
    });

    // Get name for greeting — check multiple sources
    let greeting = "there";

    // 1. Email answer from quiz
    const emailAnswer = (state.answers || []).find((a) => a.type === "email");
    const quizEmail = emailAnswer ? emailAnswer.value : "";

    // 2. Klaviyo stored identity
    const klaviyoEmail = (() => {
      try {
        const kl = localStorage.getItem("klaviyoOnsite");
        if (kl) {
          const parsed = JSON.parse(kl);
          return parsed?.identify?.email || parsed?.activeIdentity?.email || "";
        }
      } catch (e) {}
      return "";
    })();

    // 3. Shopify customer first name (passed from Liquid)
    const customerName = container?.dataset?.customerFirstName || "";

    if (customerName) {
      greeting = customerName;
    } else {
      const email = quizEmail || klaviyoEmail;
      if (email) {
        const namePart = email.split("@")[0].split(".")[0].split("+")[0];
        greeting = namePart.charAt(0).toUpperCase() + namePart.slice(1);
      }
    }

    return {
      greeting,
      skinType:
        skinTypeChoices.map((c) => c.label).join(", ") || "Not specified",
      concerns: concernChoices.map((c) => c.label),
      sensitivity: sensitivityChoices.map((c) => c.label).join(", "),
      age: ageChoices.map((c) => c.label).join(", "),
      allUpvotedTags,
    };
  }

  // ── Render full page ──────────────────────────────────────────────────────
  function renderPage(profile, state) {
    // Apply color and font overrides as CSS custom properties
    container.style.setProperty("--qr-lavender", settings.colorLavender);
    container.style.setProperty(
      "--qr-lavender-light",
      settings.colorLavenderLight,
    );
    container.style.setProperty("--qr-lavender-mid", settings.colorLavenderMid);
    container.style.setProperty("--qr-accent", settings.colorAccent);
    container.style.setProperty("--qr-black", settings.colorBlack);
    container.style.setProperty(
      "--qr-font-heading",
      settings.fontHeading + ", sans-serif",
    );
    container.style.setProperty(
      "--qr-font-body",
      settings.fontBody + ", sans-serif",
    );
    container.style.setProperty(
      "--qr-size-heading",
      settings.fontSizeHeading + "px",
    );
    container.style.setProperty("--qr-size-body", settings.fontSizeBody + "px");
    container.style.setProperty(
      "--qr-size-step-heading",
      settings.fontSizeStepHeading + "px",
    );
    container.style.setProperty(
      "--qr-size-product-title",
      settings.fontSizeProductTitle + "px",
    );
    container.style.setProperty(
      "--qr-size-price",
      settings.fontSizePrice + "px",
    );
    container.style.setProperty(
      "--qr-size-button",
      settings.fontSizeButton + "px",
    );

    container.innerHTML = `
      <div class="qr-page">
        ${renderHero(profile)}
        ${settings.showRewards ? renderRewardsBanner() : ""}
        ${renderBundleBar()}
        <div class="qr-steps" id="qr-steps-container">
          ${STEP_DEFINITIONS.map((step, i) => renderStepSkeleton(step, i)).join("")}
        </div>
        ${settings.showEmail ? renderEmailSection() : ""}
        ${renderStickyBar(quizPageUrl)}
      </div>
      <div class="qr-toast" id="qr-toast"></div>
    `;

    // Bind events
    bindBundleBarBtn();
    bindStickyAtcBtn();
    bindEmailForm();
    bindRetakeBtn();

    // Fetch products for each step
    STEP_DEFINITIONS.forEach((step, i) => {
      fetchStepProducts(step, i, profile.allUpvotedTags || []);
    });
  }

  // ── Hero ─────────────────────────────────────────────────────────────────
  function renderHero(profile) {
    const concernsText =
      profile.concerns && profile.concerns.length
        ? profile.concerns.map((c) => `<strong>${c}</strong>`).join(", ")
        : "Not specified";

    return `
      <div class="qr-hero">
        <div class="qr-hero__left">
          <div class="qr-hero-text">
            <div class="qr-hero__heading">${settings.heroHeading}</div>
            <div class="qr-hero__subtext">${settings.heroSubtext}</div>
          </div>
          <div class="qr-profile-box">
            <p class="qr-profile-box__intro">We've listened to your skin's needs! Here is your profile:</p>
            <ul class="qr-profile-box__list">
              <li class="qr-profile-box__item">
                <span class="qr-profile-box__label">Current Skin:</span>
                <span class="qr-profile-box__value"><strong>${escHtml(profile.skinType)}${profile.sensitivity === "Yes" ? " · Sensitive" : ""}.</strong></span>
              </li>
              <li class="qr-profile-box__item">
                <span class="qr-profile-box__label">Focus Areas:</span>
                <span class="qr-profile-box__value">${concernsText}.</span>
              </li>
            </ul>
            <a href="#qr-email-section" class="qr-save-btn">Email Me My Results</a>
          </div>
        </div>
        <div class="qr-hero__image">
          <img
            src="${escHtml(settings.heroImage)}"
            alt="${escHtml(settings.heroImageAlt)}"
            loading="eager"
          />
        </div>
      </div>
    `;
  }

  // ── Rewards Banner ────────────────────────────────────────────────────────
  function renderRewardsBanner() {
    return `
      <div class="qr-rewards-banner">
        <div class="qr-rewards-banner__inner">
          <span class="qr-rewards-banner__icon">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.2514 8.70005C23.3884 6.0447 20.9627 4.3454 18.3244 4.27138C17.4399 1.78565 15.0728 0 12.2835 0C9.49414 0 7.12706 1.78257 6.24249 4.27138C3.60419 4.3454 1.17855 6.04778 0.315555 8.70005C-0.547441 11.3554 0.417265 14.1588 2.50695 15.7686C1.76107 18.3006 2.63023 21.1349 4.88635 22.7756C7.14247 24.4163 10.1044 24.3638 12.2835 22.8743C14.4594 24.3669 17.4245 24.4163 19.6806 22.7756C21.9367 21.1349 22.8059 18.3006 22.06 15.7686C24.1497 14.1588 25.1144 11.3554 24.2514 8.70005Z" fill="#CAC4F4"/></svg>
          </span>
          <div class="qr-rewards-banner__content">
            <p class="qr-rewards-banner__title">${escHtml(settings.rewardsTitle)}</p>
            <p class="qr-rewards-banner__text">${settings.rewardsText}</p>
          </div>
        </div>
      </div>
    `;
  }

  // ── Bundle Bar ────────────────────────────────────────────────────────────
  function renderBundleBar() {
    return `
      <div class="qr-bundle-bar">
        <div class="qr-bundle-bar__inner">
          <div class="qr-bundle-bar__left">
            <p class="qr-bundle-bar__heading">${escHtml(settings.bundleHeading)}</p>
            <p class="qr-bundle-bar__subtext">${escHtml(settings.bundleSubtext)}</p>
          </div>
          <button class="qr-bundle-bar__btn" id="qr-add-all-top">${escHtml(settings.bundleBtnText)}</button>
        </div>
      </div>
    `;
  }

  // ── Step Skeleton ─────────────────────────────────────────────────────────
  function renderStepSkeleton(step, index) {
    const badgeClass = step.optional
      ? "qr-step__badge qr-step__badge--optional"
      : "qr-step__badge";
    const thumbnail = step.image
      ? `<div class="qr-step__thumbnail">
          <img src="${escHtml(step.image)}" alt="${escHtml(step.name)}" loading="lazy" />
         </div>`
      : "";
    const sublabel = step.sublabel
      ? `<span class="qr-step__sublabel">
          ${
            step.sublabelIcon
              ? `<img src="${escHtml(step.sublabelIcon)}" class="qr-step__sublabel-icon" alt="" />`
              : ""
          }
          ${escHtml(step.sublabel)}
        </span>`
      : "";

    return `
      <div class="qr-step" id="qr-step-${index}">
        <div class="qr-step__left">
          <div class="qr-step__badges">
            <span class="${badgeClass}">${escHtml(step.label)}</span>
            ${sublabel}
          </div>
          <div class="qr-step__desc-thumb">
            ${thumbnail}
            <div class="qr-step__desc-thumb__content">
              <h2 class="qr-step__heading">${escHtml(step.name)}</h2>
              <p class="qr-step__description">${escHtml(step.description)}</p>
            </div>
          </div>
        </div>
        <div class="qr-step__right" id="qr-step-products-${index}">
          ${renderCardSkeleton()}
        </div>
      </div>
    `;
  }

  function renderCardSkeleton() {
    return `
      <div class="qr-product-card qr-product-card--skeleton">
        <div class="qr-product-card__image-wrap">
          <div class="qr-skeleton" style="width:100%;height:100%;"></div>
        </div>
        <div class="qr-product-card__body">
          <div class="qr-skeleton" style="height:12px;width:60%;margin-bottom:8px;"></div>
          <div class="qr-skeleton" style="height:12px;width:80%;margin-bottom:6px;"></div>
          <div class="qr-skeleton" style="height:12px;width:40%;margin-bottom:14px;"></div>
          <div class="qr-skeleton" style="height:36px;width:100%;border-radius:100px;"></div>
        </div>
      </div>
    `;
  }

  // ── Email Section ─────────────────────────────────────────────────────────
  function renderEmailSection() {
    return `
      <div class="qr-email-section" id="qr-email-section">
        <div class="qr-email-section__left">
          <h2 class="qr-email-section__heading">${escHtml(settings.emailHeading)}</h2>
          <form class="qr-email-section__form" id="qr-email-form" novalidate>
            <input
              type="email"
              class="qr-email-section__input"
              id="qr-email-input"
              placeholder="Type your email"
              autocomplete="email"
            />
            <button type="submit" class="qr-email-section__submit" disabled>Submit</button>
          </form>
          <p class="qr-email-section__fine-print">
            ${escHtml(settings.emailFinePrint)}<br><br>
            *If you want to earn <a href="${escHtml(rewardsPageUrl)}">Besties Points</a> for completing the quiz, make sure you're using the same email that is associated with your account.
          </p>
        </div>
        <div class="qr-email-section__image">
          <img
            src="${escHtml(settings.emailImage)}"
            alt="Kiyoko skincare"
            loading="lazy"
          />
        </div>
      </div>
    `;
  }

  // ── Sticky Bar ────────────────────────────────────────────────────────────
  function renderStickyBar(quizUrl) {
    const retakeIcon = settings.stickyRetakeIcon
      ? `<img src="${escHtml(settings.stickyRetakeIcon)}" class="qr-sticky-bar__icon" alt="" />`
      : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.55 22.42C14.22 22.42 13.91 22.2 13.82 21.86C13.71 21.46 13.95 21.05 14.36 20.94C18.42 19.87 21.25 16.19 21.25 11.99C21.25 6.89 17.1 2.74 12 2.74C7.67 2.74 4.83 5.27 3.5 6.8H6.44C6.85 6.8 7.19 7.14 7.19 7.55C7.19 7.96 6.86 8.31 6.44 8.31H2.01C1.96 8.31 1.87 8.3 1.8 8.28C1.71 8.25 1.63 8.21 1.56 8.16C1.47 8.1 1.4 8.02 1.35 7.93C1.3 7.84 1.26 7.73 1.25 7.62C1.25 7.59 1.25 7.57 1.25 7.54V3C1.25 2.59 1.59 2.25 2 2.25C2.41 2.25 2.75 2.59 2.75 3V5.39C4.38 3.64 7.45 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 16.88 19.46 21.16 14.74 22.4C14.68 22.41 14.61 22.42 14.55 22.42Z" fill="currentColor"/><path d="M11.29 22.73C11.27 22.73 11.25 22.72 11.24 22.72C10.16 22.65 9.1 22.41 8.1 22.02C7.81 21.91 7.61 21.62 7.62 21.31C7.62 21.22 7.64 21.13 7.67 21.05C7.82 20.67 8.27 20.48 8.64 20.62C9.51 20.96 10.42 21.16 11.34 21.23C11.73 21.25 12.04 21.59 12.04 21.99L12.03 22.03C12.01 22.42 11.68 22.73 11.29 22.73ZM5.78 20.58C5.61 20.58 5.45 20.52 5.31 20.42C4.47 19.74 3.73 18.95 3.13 18.07C3.04 17.94 2.99 17.8 2.99 17.65C2.99 17.4 3.11 17.17 3.32 17.03C3.65 16.8 4.13 16.89 4.36 17.21C4.36 17.22 4.36 17.22 4.36 17.22C4.37 17.23 4.38 17.25 4.39 17.26C4.91 18.01 5.54 18.68 6.25 19.24C6.42 19.38 6.53 19.59 6.53 19.82C6.53 19.99 6.48 20.16 6.37 20.3C6.22 20.48 6.01 20.58 5.78 20.58ZM2.44 15.7C2.11 15.7 1.82 15.49 1.73 15.18C1.41 14.15 1.25 13.08 1.25 12V11.99C1.26 11.58 1.59 11.25 2 11.25C2.41 11.25 2.75 11.59 2.75 12C2.75 12.94 2.89 13.86 3.16 14.73C3.18 14.81 3.19 14.88 3.19 14.96C3.19 15.28 2.98 15.57 2.66 15.67C2.59 15.69 2.52 15.7 2.44 15.7Z" fill="currentColor"/></svg>`;

    const atcIcon = settings.stickyAtcIcon
      ? `<img src="${escHtml(settings.stickyAtcIcon)}" class="qr-sticky-bar__icon" alt="" />`
      : `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.25 3.91357H3.06665C4.10706 3.91357 5.02551 4.6145 5.29944 5.61865L7.17847 12.5939C7.62524 14.2579 9.14026 15.4199 10.8629 15.4199H18.2062C19.9574 15.4199 21.4786 14.2338 21.906 12.5356L22.3832 10.6387C22.6721 9.49023 22.4202 8.29602 21.6921 7.36218C20.9641 6.42834 19.8677 5.89258 18.6833 5.89258H9.82251C9.40833 5.89258 9.07251 6.22839 9.07251 6.64258C9.07251 7.05676 9.40833 7.39258 9.82251 7.39258H18.6833C19.4019 7.39258 20.0676 7.71777 20.5093 8.2843C20.9509 8.8512 21.104 9.57556 20.9286 10.2725L20.4514 12.1694C20.1921 13.2003 19.2689 13.9199 18.2062 13.9199H10.8629C9.81775 13.9199 8.89819 13.2146 8.6272 12.205L6.7467 5.22314C6.2948 3.56897 4.78162 2.41357 3.06665 2.41357H2.25C1.83582 2.41357 1.5 2.74939 1.5 3.16357C1.5 3.57776 1.83582 3.91357 2.25 3.91357ZM12.899 18.8781C12.899 17.3846 11.6843 16.1699 10.1909 16.1699C8.69751 16.1699 7.48279 17.3846 7.48279 18.8781C7.48279 20.3715 8.69751 21.5862 10.1909 21.5862C11.6843 21.5862 12.899 20.3715 12.899 18.8781ZM8.98279 18.8781C8.98279 18.2119 9.52478 17.6699 10.1909 17.6699C10.8571 17.6699 11.399 18.2119 11.399 18.8781C11.399 19.5442 10.8571 20.0862 10.1909 20.0862C9.52478 20.0862 8.98279 19.5442 8.98279 18.8781ZM21.5903 18.8781C21.5903 17.3846 20.3756 16.1699 18.8822 16.1699C17.3888 16.1699 16.1741 17.3846 16.1741 18.8781C16.1741 20.3715 17.3888 21.5862 18.8822 21.5862C20.3756 21.5862 21.5903 20.3715 21.5903 18.8781ZM18.8822 20.0862C18.2161 20.0862 17.6741 19.5442 17.6741 18.8781C17.6741 18.2119 18.2161 17.6699 18.8822 17.6699C19.5483 17.6699 20.0903 18.2119 20.0903 18.8781C20.0903 19.5442 19.5483 20.0862 18.8822 20.0862Z" fill="currentColor"/>
        </svg>`;

    return `
      <div class="qr-sticky-bar">
        <div class="inner">
          <a href="${escHtml(quizUrl)}" class="qr-sticky-bar__retake" id="qr-retake-btn">
              ${retakeIcon}
              <span class="qr-sticky-bar__text--desktop">${escHtml(settings.stickyRetakeText)}</span>
              <span class="qr-sticky-bar__text--mobile">${escHtml(settings.stickyRetakeTextMobile)}</span>
            </a>
            <button class="qr-sticky-bar__atc" id="qr-add-all-sticky">
              ${atcIcon}
              <span class="qr-sticky-bar__text--desktop">${escHtml(settings.stickyDiscountText)}</span>
              <span class="qr-sticky-bar__text--mobile">${escHtml(settings.stickyDiscountTextMobile)}</span>
            </button>
        </div>
      </div>
    `;
  }

  // ── Fetch products per step ───────────────────────────────────────────────
  async function fetchStepProducts(step, index, upvotedTags) {
    const productsContainer = document.getElementById(
      `qr-step-products-${index}`,
    );
    if (!productsContainer) return;

    const products = await fetchViaAjax(step, upvotedTags);

    if (!products || products.length === 0) {
      productsContainer.innerHTML = `<p class="qr-step__no-products">We're working on personalised picks for this step — check back soon!</p>`;
      return;
    }

    // Register available variants for Add All to Cart
    products.forEach((p) => {
      if (p.variantId && p.available && !allVariantIds.includes(p.variantId)) {
        allVariantIds.push(p.variantId);
      }
    });
    // Expose for debugging
    window._qrVariantIds = allVariantIds;

    productsContainer.innerHTML = products
      .map((p) => renderProductCard(p))
      .join("");

    // Bind ATC buttons
    productsContainer
      .querySelectorAll(".qr-product-card__atc")
      .forEach((btn) => {
        btn.addEventListener("click", handleAddToCart);
      });

    // Bind quick view buttons
    productsContainer
      .querySelectorAll(".qr-product-card__quick-view")
      .forEach((btn) => {
        btn.addEventListener("click", handleQuickView);
      });

    // Trigger Yotpo to render stars on newly injected widgets
    if (window.yotpo && window.yotpo.initialized) {
      window.yotpo.refreshWidgets();
    }

    // Observe Yotpo rendering and reformat review text
    observeYotpoReviews(productsContainer);
  }

  // ── Quick view handler ───────────────────────────────────────────────────
  async function handleQuickView(e) {
    const btn = e.currentTarget;
    const handle = btn.dataset.productHandle;
    const title = btn.dataset.productTitle;
    if (!handle) return;

    btn.style.opacity = "0.5";
    btn.style.pointerEvents = "none";

    try {
      // Find any existing quick-add-component on the page to piggyback on
      // its fetchProductPage + updateQuickAddModal + showDialog methods
      let quickAddComponent = document.querySelector("quick-add-component");

      // If none exists on page, create a temporary one
      if (!quickAddComponent) {
        quickAddComponent = document.createElement("quick-add-component");
        quickAddComponent.style.display = "none";
        document.body.appendChild(quickAddComponent);
      }

      // Set the product title so the modal header updates correctly
      quickAddComponent.dataset.productTitle = title;

      // Fetch the product page and let the component handle injection + morph
      await quickAddComponent.fetchProductPage(`/products/${handle}`);

      if (quickAddComponent.cachedProductHtml) {
        // Must pass a fresh copy each time — same as the theme does
        const freshCopy = new DOMParser().parseFromString(
          quickAddComponent.cachedProductHtml.documentElement.outerHTML,
          "text/html",
        );
        await quickAddComponent.updateQuickAddModal(freshCopy);
      }

      // Dispatch the same event the theme fires after quick-add opens
      document.dispatchEvent(new CustomEvent("quick-atc-slider:init"));

      // Open the dialog
      const dialogComponent = document.getElementById("quick-add-dialog");
      if (dialogComponent && typeof dialogComponent.showDialog === "function") {
        dialogComponent.showDialog();
      }
    } catch (err) {
      console.warn("[QuizResults] Quick view failed, navigating:", err);
      window.location.href = `/products/${handle}`;
    } finally {
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
    }
  }

  // ── Yotpo review text reformatter ────────────────────────────────────────
  function observeYotpoReviews(scope) {
    const observer = new MutationObserver(() => {
      scope.querySelectorAll(".qr-product-card__stars").forEach((starEl) => {
        // Target the text element Yotpo renders with the review count
        const textEl =
          starEl.querySelector(".yotpo-sr-bottom-line-right-panel p") ||
          starEl.querySelector(".yotpo-sr-bottom-line-text");

        if (!textEl || textEl.dataset.qrFormatted) return;

        const raw = textEl.textContent.trim();
        // Extract just the number from strings like "26 Reviews" or "26"
        const match = raw.match(/(\d+)/);
        if (match) {
          textEl.textContent = "";
          const span = document.createElement("span");
          span.className = "qr-review-count";
          span.textContent = "(" + match[1] + ")";
          textEl.appendChild(span);
          textEl.dataset.qrFormatted = "true";
        }
      });
    });

    observer.observe(scope, { childList: true, subtree: true });

    // Disconnect after 5s to avoid memory leak
    setTimeout(() => observer.disconnect(), 5000);
  }

  // ── Storefront API fetch ──────────────────────────────────────────────────
  async function fetchViaStorefrontAPI(step, upvotedTags) {
    const products = [];

    for (const collectionId of step.collectionIds) {
      const gid = `gid://shopify/Collection/${collectionId}`;

      // Build tag filters from upvoted tags
      const tagFilters = upvotedTags.length
        ? upvotedTags.map((tag) => `{ tag: "${tag}" }`).join(", ")
        : "";

      const filtersArg = tagFilters ? `, filters: [${tagFilters}]` : "";

      const query = `{
        collection(id: "${gid}") {
          products(first: 2${filtersArg}, sortKey: BEST_SELLING) {
            edges {
              node {
                id
                title
                handle
                vendor
                featuredImage { url(transform: { maxWidth: 400, maxHeight: 400 }) }
                priceRange { minVariantPrice { amount currencyCode } }
                variants(first: 1) { edges { node { id } } }
                availableForSale
              }
            }
          }
        }
      }`;

      try {
        const resp = await fetch(
          `https://${shopDomain}/api/2024-01/graphql.json`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": sfToken,
            },
            body: JSON.stringify({ query }),
          },
        );
        const data = await resp.json();
        const edges = data?.data?.collection?.products?.edges || [];

        // If no results with tag filters, retry without filters
        if (edges.length === 0 && tagFilters) {
          const fallback = await fetch(
            `https://${shopDomain}/api/2024-01/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": sfToken,
              },
              body: JSON.stringify({
                query: `{
                collection(id: "${gid}") {
                  products(first: 2, sortKey: BEST_SELLING) {
                    edges { node {
                      id title handle vendor
                      featuredImage { url(transform: { maxWidth: 400, maxHeight: 400 }) }
                      priceRange { minVariantPrice { amount currencyCode } }
                      variants(first: 1) { edges { node { id } } }
                      availableForSale
                    } }
                  }
                }
              }`,
              }),
            },
          );
          const fallbackData = await fallback.json();
          const fallbackEdges =
            fallbackData?.data?.collection?.products?.edges || [];
          fallbackEdges.forEach(({ node }) => {
            if (products.length < 2)
              products.push(normalizeStorefrontProduct(node));
          });
        } else {
          edges.forEach(({ node }) => {
            if (products.length < 2)
              products.push(normalizeStorefrontProduct(node));
          });
        }
      } catch (e) {
        console.warn("[QuizResults] Storefront API error:", e);
      }

      if (products.length >= 2) break;
    }

    return products;
  }

  function normalizeStorefrontProduct(node) {
    const variantGid = node.variants?.edges?.[0]?.node?.id || "";
    const variantId = variantGid.replace("gid://shopify/ProductVariant/", "");
    const price = node.priceRange?.minVariantPrice;
    const amount = price ? parseFloat(price.amount).toFixed(2) : null;
    const currency = price?.currencyCode || "CAD";

    return {
      id: node.id,
      title: node.title,
      handle: node.handle,
      vendor: node.vendor,
      image: node.featuredImage?.url || "",
      price: amount ? `${currency} $${amount}` : "",
      variantId: variantId,
      available: node.availableForSale,
    };
  }

  // ── AJAX API fetch ───────────────────────────────────────────────────────
  async function fetchViaAjax(step, upvotedTags) {
    // Fetch more products so we can filter by tags and swap out sold-out items
    const FETCH_LIMIT = 12;

    for (const collectionHandle of step.collectionHandles) {
      try {
        const resp = await fetch(
          `/collections/${collectionHandle}/products.json?limit=${FETCH_LIMIT}&sort_by=best-selling`,
        );
        if (!resp.ok) continue;
        const data = await resp.json();
        if (!data.products || data.products.length === 0) continue;

        // Normalize all products
        const normalized = data.products.map((item) => {
          const variant =
            item.variants.find((v) => v.available) || item.variants[0];
          const image =
            variant?.featured_image?.src || item.images?.[0]?.src || "";
          const images =
            item.images?.map((img) => img.src) || (image ? [image] : []);
          const price = variant ? parseFloat(variant.price) : null;
          const compareAt = variant
            ? parseFloat(variant.compare_at_price)
            : null;
          return {
            id: item.id,
            title: item.title,
            handle: item.handle,
            vendor: item.vendor || "",
            tags: item.tags || [],
            image,
            images,
            price: price ? `$${price.toFixed(2)}` : "",
            compareAt:
              compareAt && compareAt > price
                ? `$${compareAt.toFixed(2)}`
                : null,
            variantId: variant ? variant.id : null,
            available: variant ? variant.available : false,
          };
        });

        // Score products by how many upvoted tags they match
        const scored = normalized.map((p) => {
          const matchCount = upvotedTags.filter((tag) =>
            p.tags.some((t) => t.toLowerCase() === tag.toLowerCase()),
          ).length;
          return { ...p, matchCount };
        });

        // Sort: available first, then by tag match score, then by position
        scored.sort((a, b) => {
          if (a.available !== b.available) return a.available ? -1 : 1;
          return b.matchCount - a.matchCount;
        });

        // Return top 1 — best available match
        const results = scored.slice(0, 1);
        if (results.length > 0) return results;
      } catch (e) {
        console.warn("[QuizResults] AJAX fetch error:", e);
      }
    }

    return [];
  }

  function renderProductCard(product) {
    const stars = `<div class="yotpo-widget-instance" data-yotpo-instance-id="1160831" data-yotpo-product-id="${product.id}" style="min-height:18px;"></div>`;

    const imageHtml = product.image
      ? `<img src="${escHtml(product.image)}" alt="${escHtml(product.title)}" loading="lazy" />`
      : `<div style="width:100%;height:100%;background:#f0eef8;"></div>`;

    const wishlistBtn = product.variantId
      ? `
      <wishlist-button-collection
        data-product-handle="${escHtml(product.handle)}"
        data-variant-id="${escHtml(String(product.variantId))}"
        show-icon=""
        icon="wishlist"
        align-self="center"
        align-content="center"
      ></wishlist-button-collection>`
      : "";

    const atcDisabled =
      !product.available || !product.variantId
        ? 'disabled style="opacity:0.5;cursor:default;"'
        : "";

    return `
      <div class="qr-product-card">
        <div class="qr-product-card__image-wrap">
          ${imageHtml}
          <button
            class="qr-product-card__quick-view"
            aria-label="Quick view ${escHtml(product.title)}"
            data-product-handle="${escHtml(product.handle)}"
            data-product-title="${escHtml(product.title)}"
            type="button"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.6806 10.8516C22.9649 11.1666 23.1222 11.5759 23.1222 12.0002C23.1222 12.4245 22.9649 12.8338 22.6806 13.1488C20.8806 15.0859 16.7834 18.8574 12.0006 18.8574C7.21772 18.8574 3.12057 15.0859 1.32057 13.1488C1.03628 12.8338 0.878906 12.4245 0.878906 12.0002C0.878906 11.5759 1.03628 11.1666 1.32057 10.8516C3.12057 8.91449 7.21772 5.14307 12.0006 5.14307C16.7834 5.14307 20.8806 8.91449 22.6806 10.8516Z" stroke="#131112" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.0008 15.4289C13.8944 15.4289 15.4294 13.8939 15.4294 12.0003C15.4294 10.1068 13.8944 8.57178 12.0008 8.57178C10.1073 8.57178 8.57227 10.1068 8.57227 12.0003C8.57227 13.8939 10.1073 15.4289 12.0008 15.4289Z" stroke="#131112" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="qr-product-card__body">
          <div class="qr-product-card__stars-row">
            <div class="qr-product-card__stars">${stars}</div>
            ${wishlistBtn}
          </div>
          ${product.vendor ? `<p class="qr-product-card__vendor">${escHtml(product.vendor)}</p>` : ""}
          <a href="/products/${escHtml(product.handle)}" class="qr-product-card__title">${escHtml(product.title)}</a>
          <p class="qr-product-card__price">
            ${product.compareAt ? `<span class="qr-product-card__compare-at">${escHtml(product.compareAt)}</span> ` : ""}
            <span class="qr-product-card__price-amount">
              <span class="qr-product-card__currency">${escHtml(product.price.charAt(0))}</span>${escHtml(product.price.slice(1))}
            </span>
          </p>
          <button
            class="qr-product-card__atc"
            data-variant-id="${escHtml(product.variantId || "")}"
            data-product-title="${escHtml(product.title)}"
            ${atcDisabled}
          >
            ${product.available ? "Add to Cart" : "Sold Out"}
          </button>
        </div>
      </div>
    `;
  }

  // ── Add to cart ───────────────────────────────────────────────────────────
  async function handleAddToCart(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    const title = btn.dataset.productTitle;
    if (!variantId) return;

    btn.classList.add("loading");
    btn.textContent = "Adding...";

    const success = await addToCart(variantId, 1);

    if (success) {
      btn.classList.remove("loading");
      btn.classList.add("added");
      btn.textContent = "✓ Added";
      showToast(`${title} added to cart`);
      setTimeout(() => {
        btn.classList.remove("added");
        btn.textContent = "Add to Cart";
      }, 2500);
    } else {
      btn.classList.remove("loading");
      btn.textContent = "Try Again";
      setTimeout(() => {
        btn.textContent = "Add to Cart";
      }, 2000);
    }
  }

  async function addToCart(variantId, quantity) {
    try {
      const resp = await fetch("/cart/add.json", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity }),
      });
      if (!resp.ok) return false;
      // Trigger cart update event for theme cart drawer
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return true;
    } catch (e) {
      return false;
    }
  }

  async function handleAddAllToCart(btn) {
    if (!allVariantIds.length) {
      showToast("Products are still loading, please wait.");
      return;
    }

    btn.classList.add("loading");
    const originalHTML = btn.innerHTML;
    btn.textContent = "Adding...";

    const items = allVariantIds
      .filter((id) => id && !isNaN(parseInt(id, 10)))
      .map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

    console.log("[QuizResults] Add All payload:", items);

    if (!items.length) {
      showToast("No available products to add.");
      btn.classList.remove("loading");
      btn.textContent = originalText;
      return;
    }

    try {
      const resp = await fetch("/cart/add.json", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (resp.ok) {
        btn.classList.remove("loading");
        btn.textContent = "✓ All Added!";
        showToast("All products added to cart!");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        // Mark all individual ATC buttons as added
        document.querySelectorAll(".qr-product-card__atc").forEach((b) => {
          b.classList.add("added");
          b.textContent = "✓ Added";
        });
        setTimeout(() => {
          btn.innerHTML = originalHTML;
        }, 3000);
      } else {
        btn.classList.remove("loading");
        btn.innerHTML = originalHTML;
        showToast("Something went wrong. Please try again.");
      }
    } catch (e) {
      btn.classList.remove("loading");
      btn.innerHTML = originalHTML;
    }
  }

  // ── Event bindings ────────────────────────────────────────────────────────
  function bindBundleBarBtn() {
    const btn = document.getElementById("qr-add-all-top");
    if (btn) btn.addEventListener("click", () => handleAddAllToCart(btn));
  }

  function bindStickyAtcBtn() {
    const btn = document.getElementById("qr-add-all-sticky");
    if (btn) btn.addEventListener("click", () => handleAddAllToCart(btn));
  }

  function showRetakeConfirm(onConfirm) {
    // Remove any existing modal
    document.getElementById("qr-retake-modal")?.remove();

    const modal = document.createElement("div");
    modal.id = "qr-retake-modal";
    modal.innerHTML = `
      <div class="qr-retake-modal__overlay">
        <div class="qr-retake-modal__box">
          <h3 class="qr-retake-modal__heading">Retake the quiz?</h3>
          <p class="qr-retake-modal__text">Retaking the quiz will remove your current routine items from the cart and clear your discount.</p>
          <div class="qr-retake-modal__actions">
            <button class="qr-retake-modal__cancel">Keep My Routine</button>
            <button class="qr-retake-modal__confirm">Yes, Retake Quiz</button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal
      .querySelector(".qr-retake-modal__cancel")
      .addEventListener("click", () => {
        modal.remove();
      });

    modal
      .querySelector(".qr-retake-modal__confirm")
      .addEventListener("click", () => {
        modal.remove();
        onConfirm();
      });

    // Close on overlay click
    modal
      .querySelector(".qr-retake-modal__overlay")
      .addEventListener("click", (e) => {
        if (e.target === e.currentTarget) modal.remove();
      });
  }

  function bindRetakeBtn() {
    const btn = document.getElementById("qr-retake-btn");
    if (!btn) return;
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      showRetakeConfirm(async () => {
        localStorage.removeItem(LS_KEY);
        localStorage.removeItem("kiyoko_routine_variants");

        // Clear cart and remove discount before redirecting
        try {
          await fetch("/cart/clear.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ discount: "" }),
          });
        } catch (_e) {}

        window.location.href = "/pages/kiyokos-skincare-quiz-1";
      });
    });
  }

  function bindEmailForm() {
    const form = document.getElementById("qr-email-form");
    if (!form) return;

    const input = document.getElementById("qr-email-input");
    const submitBtn = form.querySelector(".qr-email-section__submit");

    // Toggle disabled state based on input value
    if (input && submitBtn) {
      input.addEventListener("input", () => {
        const val = input.value.trim();
        submitBtn.disabled = !val || !val.includes("@");
      });
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const email = input ? input.value.trim() : "";
      if (!email || !email.includes("@")) {
        showToast("Please enter a valid email address.");
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = "Saving...";

      // responseId is stored as JSON {value, expiry} — extract just the value
      let responseId = "";
      try {
        const raw = localStorage.getItem(`revenuehunt-responseId-${QUIZ_ID}`);
        if (raw) {
          const parsed = JSON.parse(raw);
          responseId = parsed?.value || parsed || "";
        }
      } catch (e) {
        responseId =
          localStorage.getItem(`revenuehunt-responseId-${QUIZ_ID}`) || "";
      }
      const resultsUrl = window.location.href;

      // Scrape rendered product cards from DOM — all products per step
      const products = {};
      try {
        STEP_DEFINITIONS.forEach((step, i) => {
          const stepEl = document.getElementById(`qr-step-products-${i}`);
          if (!stepEl) return;
          const cards = stepEl.querySelectorAll(".qr-product-card");
          if (!cards.length) return;
          const safeKey = step.slotRef.replace(/-/g, "_");
          const items = [];
          cards.forEach((card) => {
            const titleEl = card.querySelector(".qr-product-card__title");
            const priceEl = card.querySelector(".qr-product-card__price");
            const vendorEl = card.querySelector(".qr-product-card__vendor");
            const imgEl = card.querySelector("img");
            if (!titleEl?.textContent?.trim()) return;
            items.push({
              title: titleEl?.textContent?.trim() || "",
              url: titleEl?.href || "",
              image: imgEl?.src || "",
              price: priceEl?.textContent?.trim().replace(/\s+/g, " ") || "",
              vendor: vendorEl?.textContent?.trim() || "",
            });
          });
          if (!items.length) return;
          products[safeKey] = {
            heading: step.name || "",
            description: step.label || "",
            items,
            // Keep first item at top level for backward compat
            title: items[0].title,
            url: items[0].url,
            image: items[0].image,
            price: items[0].price,
            vendor: items[0].vendor,
          };
        });
      } catch (e) {
        console.warn("[QuizResults] DOM scrape error:", e);
      }

      // Scrape skin profile from the rendered hero section
      const skinProfile = {};
      try {
        const profileBox = document.querySelector(".qr-profile-box");
        if (profileBox) {
          const values = profileBox.querySelectorAll(".qr-profile-box__value");
          if (values[0])
            skinProfile.skin_type = values[0].textContent
              .trim()
              .replace(/\.$/, "");
          if (values[1])
            skinProfile.skin_concerns = values[1].textContent
              .trim()
              .replace(/\.$/, "");
        }
      } catch (e) {}

      try {
        const key = klaviyoKey || "VmjaKy";

        // Step 1 — Create/update Klaviyo profile
        await fetch(
          "https://a.klaviyo.com/client/profiles/?company_id=" + key,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              revision: "2024-02-15",
            },
            body: JSON.stringify({
              data: {
                type: "profile",
                attributes: {
                  email,
                  properties: {
                    quiz_response_id: responseId,
                    quiz_results_url: resultsUrl,
                    quiz_id: QUIZ_ID,
                  },
                },
              },
            }),
          },
        );

        // Step 2 — Track "Quiz Results Requested" event with product data
        await fetch("https://a.klaviyo.com/client/events/?company_id=" + key, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-02-15",
          },
          body: JSON.stringify({
            data: {
              type: "event",
              attributes: {
                metric: {
                  data: {
                    type: "metric",
                    attributes: { name: "Quiz Results Requested" },
                  },
                },
                profile: { data: { type: "profile", attributes: { email } } },
                properties: {
                  quiz_id: QUIZ_ID,
                  response_id: responseId,
                  results_url: resultsUrl,
                  products,
                  skin_type: skinProfile.skin_type || "",
                  skin_concerns: skinProfile.skin_concerns || "",
                },
              },
            },
          }),
        });

        localStorage.setItem("kiyoko_quiz_email", email);
        showToast("✓ Check your inbox for your results!");
        input.value = "";
        submitBtn.textContent = "✓ Sent";
      } catch (err) {
        console.warn("[QuizResults] Klaviyo error:", err);
        localStorage.setItem("kiyoko_quiz_email", email);
        showToast("✓ Results saved!");
        input.value = "";
        submitBtn.textContent = "✓ Sent";
      }
    });
  }

  // ── Error state ───────────────────────────────────────────────────────────
  function renderError() {
    if (!container) return;
    container.innerHTML = `
      <div class="qr-error">
        <p>We couldn't find your quiz results.</p>
        <p>It looks like your session may have expired or the quiz wasn't completed.</p>
        <a href="${escHtml(quizPageUrl)}" class="qr-error__link">Retake the Quiz</a>
      </div>
    `;
  }

  // ── Toast ─────────────────────────────────────────────────────────────────
  function showToast(message) {
    let toast = document.getElementById("qr-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "qr-toast";
      toast.className = "qr-toast";
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 3000);
  }

  // ── Utility ───────────────────────────────────────────────────────────────
  function escHtml(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
